import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function Layout() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />

      <button
        onClick={scrollTop}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all hover:bg-primary-600 ${
          showTop ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </button>
    </div>
  );
}